var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"position-relative"},[_c('vue-chartist',{staticClass:"height-300 ct-hidden-points",attrs:{"type":"Bar","data":_vm.data,"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }